import React, {useState, useEffect, useRef} from 'react';
import {closeModal, Modal as ModalComponent} from '../../common/Modal.jsx';
import {Portal} from '../../common/Portal.jsx';
import Select from '../../common/Select.jsx';
import Errors from '../../common/Errors.jsx';
import ToggleSwitch from '../../common/ToggleSwitch.jsx';

const SAVE_PRESET_MODAL_ID = 'save-preset-modal';

const defaultSettings = {
  preset_id: null,
  preset_name: '',
  description: '',
  visibility: 'all',
  editMode: 'false',
  default_in_fund_context: false,
  default_in_project_context: false
};

const SavePresetModalTrigger = ({permissions, presets, saveState, context_name}) => {
  const [openModal, setOpenModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [settings, setSettings] = useState(defaultSettings);
  const [errors, setErrors] = useState([]);

  const formRef = useRef();
  const availablePresets = permissions.presets_lock ? presets : presets.filter(v => !v.is_locked)

  const handleCloseModal = () => {
    closeModal(SAVE_PRESET_MODAL_ID);
  };
  const handleOpenModal = () => setOpenModal(true);

  const handleSave = (e) => {
    e.preventDefault();
    setSaving(true);

    saveState(
      jQuery(formRef.current).serializeArray().reduce((obj, i) => ({ ...obj, [i.name]: i.value }), {}),
      (res) => {
        if (res.errors) {
          setErrors(res.errors);
        } else {
          handleCloseModal()
        }
        setSaving(false);
      }
    );
  };

  const handleChange = (field, val) => {
    setSettings((v) => ({...v, [field]: val}))
  };

  const updateExisting = settings.editMode == 'true';

  useEffect(() => {
    setSettings(defaultSettings);
  }, [openModal]);

  return (<>
    <li className='dropdown-item mr-1 ml-1' onClick={handleOpenModal}>{I18n.t('save')}...</li>
    {openModal &&
      <Portal
        id={SAVE_PRESET_MODAL_ID}
        size='md'
        title={I18n.t('save_current_grid_configuration')}
        saveLabel={I18n.t('save')}
        cancelLabel={I18n.t('close')}
        onClose={handleCloseModal}
        onSave={handleSave}
        saving={saving}
        component={ModalComponent}
      >
        <form ref={formRef} onSubmit={handleSave}>
          <Errors errors={errors}/>

          <div className='form-group'>
            <label className='w-100'>
              <input type='radio' name='edit_preset' defaultChecked={!updateExisting} defaultValue='false' onClick={(e) => handleChange('editMode', 'false')} style={{marginRight: '0.5rem'}}/>
              {I18n.t('save_as_new')}
            </label>
            <label>
              <input type='radio' name='edit_preset' defaultChecked={updateExisting} defaultValue='true' onClick={(e) => handleChange('editMode', 'true')} style={{marginRight: '0.5rem'}}/>
              {I18n.t('update_existing')}
            </label>
          </div>

          {updateExisting ?
            <div className='form-group'>
              <label>{I18n.t('select_a_preset')} *</label>
              <Select
                name='preset_id'
                options={availablePresets.map(v => ({value: v.id, label: v.name}))}
                value={settings.preset_id}
                onChange={(val) => handleChange('preset_id', val)}
              />
            </div>
            :
            <>
              <div className='form-group'>
                <label>{I18n.t('preset_name')} *</label>
                <input
                  name='name'
                  className='form-control'
                  value={settings.preset_name}
                  onChange={(e) => handleChange('preset_name', e.target.value)}
                />
              </div>

              <div className='form-group'>
                <label>{I18n.t('description')}</label>
                <textarea
                  name='description'
                  className='form-control'
                  value={settings.description}
                  onChange={(e) => handleChange('description', e.target.value)}
                />
              </div>

              <div className='form-group'>
                <label>{I18n.t('visibility')}</label>
                <select
                  name='visibility'
                  className='form-control'
                  value={settings.visibility}
                  onChange={(e) => handleChange('visibility', e.target.value)}
                >
                  {['all', 'project_context', 'fund_context'].map((visibility) => {
                    return <option key={`preset-${visibility}`} value={visibility}>{I18n.t(visibility)}</option>;
                  })}
                </select>
              </div>

              {context_name != 'datagrid_collection' &&
                <>
                  <div className='form-group'>
                    <label className='w-100 mb-0'>{I18n.t('default_in_fund')}</label>
                    <ToggleSwitch
                      name='default_in_fund_context'
                      isOn={settings.default_in_fund_context}
                      handleToggle={() => handleChange('default_in_fund_context', !settings.default_in_fund_context)}
                    />
                  </div>

                  <div className='form-group'>
                    <label className='w-100 mb-0'>{I18n.t('default_in_project_context')}</label>
                    <ToggleSwitch
                      name='default_in_project_context'
                      isOn={settings.default_in_project_context}
                      handleToggle={() => handleChange('default_in_project_context', !settings.default_in_project_context)}
                    />
                  </div>
                </>
              }
            </>
          }
        </form>
      </Portal>
    }
  </>);
};

export default SavePresetModalTrigger;
